import React from "react";
import Chip from "@mui/material/Chip";
import moment from "moment";
import { CircularProgress, Grid, Typography } from "@mui/material";

const TimeChips = ({ dateData, value, onChange, onBlur, dateLoading }) => {
  const handleChipClick = (time) => {
    onChange(time);
    onBlur();
  };
  const { date, dateTimeArray } = dateData;
  const getTimeSlots = () => {
    const currentDate = new Date();
    let timeSlots = [];
    let selectedDate = moment(date).startOf("day");
    for (let i = 0; i < 24 * 4; i++) {
      const diff = selectedDate - currentDate;
      let flag = true;
      if (diff > 23400000) {
        dateTimeArray?.map((item) => {
          const jobDiff = Math.abs(selectedDate - new Date(item.dateTime));
          if (jobDiff < 10800000) {
            flag = false;
          }
        });
        if (flag) {
          timeSlots.push(selectedDate.format("hh:mm A"));
        }
      }
      selectedDate.add(15, "minutes");
    }
    return timeSlots;
  };

  return (
    <div
      style={{
        height: "280px",
        overflow: "auto",
      }}
    >
      {dateLoading ? (
        <Grid
          height={"100%"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <div>
            <CircularProgress />
          </div>
          <Typography color={"primary"}>
            Checking avalaible time slots
          </Typography>
        </Grid>
      ) : getTimeSlots().length > 0 ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5rem",
            justifyContent: "space-between",
          }}
        >
          {getTimeSlots().map((time, index) => (
            <Chip
              key={index}
              label={time}
              color="primary"
              variant={value === time ? "contained" : "outlined"}
              onClick={() => handleChipClick(time)}
              style={{ cursor: "pointer" }}
              sx={{
                "&:hover": {
                  backgroundColor: "#1b66b2",
                },
              }}
            />
          ))}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div style={{ width: 60, height: 60, marginBottom: 10 }}>
            <img
              width={"100%"}
              src="https://static.vecteezy.com/system/resources/thumbnails/012/227/702/small/prohibition-sign-color-png.png"
            />
          </div>
          <Typography color={"error"}>
            No time slots avalaible. Please choose a different day!
          </Typography>
        </div>
      )}
    </div>
  );
};

export default TimeChips;
